import React, { Component } from 'react'
import { connect } from 'react-redux'

// Components
import Tooltip from './../utils/Tooltip'

// State
import { updateCartQty, removeCartCoupon, clearUpdateMsg } from '../../store/actions/cart'

// Utils
import getInventory from '../../utils/inventoryUtils.js';

// CSS
import '../../css/button.css'

class UpdateQtyCell extends Component {
	constructor(props) {
		super(props)
		this.state = {
			qty: this.props.product.qty,
			quantityError: false
		}
	}

	componentWillMount() {
		this.props.clearUpdateMsg()
	}

	handleInputChange(event){
		// Ensure value is greater than 0 and an integer
		const value = event.target.value === '' || +event.target.value < 1 ? '' : +event.target.value

		// Set new qty for input
		this.setState({
			qty: value
		})
	}

	handleKeyPress(event, item_id){
		if (event.key === 'Enter'){
			if(this.shouldShowError() || this.shouldShowSuccess()){
				this.props.clearUpdateMsg()
			}else{
				this.handleUpdateQty(item_id, this.state.qty)
			}
		}
	}

	handleUpdateQty(cartItemId, qty){
		if(this.checkInventoryQuantity()){
			// this.handleCouponAutoRemove();
			this.props.updateCartQty(cartItemId, qty)
		}
	}

	//REMOVES COUPON IF THE CART TOTAL WOULD BE LOWER THAN THE COUPON REQUIREMENT
	handleCouponAutoRemove(){
		if(this.props.codes.length){
			const product 		= this.props.product;
			const code 			= this.props.codes[0];
			const productTotalToLose = product.total - (product.price * this.state.qty);
			const cartTotal 	= this.props.cart.cart_summary.total_price;
			const couponMin 	= this.props.codes.length ? code.min_sale_amount : 0;
			const newTotal 		= cartTotal - productTotalToLose;
			if(newTotal < couponMin){
				this.props.removeCartCoupon(code.id);
				this.setState({ showCouponError: true });
			}
		}
		else {
			this.setState({ showCouponError: false });
		}
	}

	// Check if customer is increasing quantity past the inventory of the item
	checkInventoryQuantity(){
		// 1) GET VALUES
		const inventory 		= getInventory(this.props.product, this.props.product.variant);
		const quantityEntered 	= parseInt(this.state.qty, 10);

		// 2.1) PRODUCT HAS NO INVENTORY SET (NULL)
		if(inventory === null || inventory === undefined)
			return this.hideQuantityTooltipError();

		// 2.2) PRODUCT HAS INVENTORY SET (>=0)
		if(quantityEntered <= inventory)
			return this.hideQuantityTooltipError();
		else
			return this.showQuantityTooltipError();
	}

	showQuantityTooltipError(){
		this.props.clearUpdateMsg();
		this.setState({quantityError: true});
		return false;
	}
	hideQuantityTooltipError(){
		this.setState({quantityError: false})
		return true;
	}

	shouldShowError(){
		return this.props.updateError !== undefined && this.props.product.id === this.props.updatedId	
	}
	shouldShowSuccess(){
		return this.props.updateSuccess !== undefined && this.props.product.id === this.props.updatedId
	}

	render() {

		const showErrorTooltip = this.shouldShowError()
		const showSuccessTooltip = this.shouldShowSuccess()

		const loading = this.props.updateInProcess && this.props.product.id === this.props.updatedId
		let showQuantityError = {qty: `There is only ${getInventory(this.props.product, this.props.product.variant)} of this item currently in stock.`}

		// Set up button classes
		let classes = 'btn'
		if(this.state.qty === this.props.product.qty) classes += ' hidden_element'
		if(loading) classes += ' loading'
		
		return (
			<div>
				<input
					className="qty"
					ref={(tooltipParentName) => this.tooltipParentName = tooltipParentName }
					type="number"
					min="1"
					step="1"
					name="qty"
					placeholder="0"
					value={this.state.qty}
					onKeyPress={e => this.handleKeyPress(e, this.props.product.id)}
					onChange={event => this.handleInputChange(event)}
				/>
				<div className="btn_container">
					<button
						className={classes}
						name="update"
						onClick={() => this.handleUpdateQty(this.props.product.id, this.state.qty)}
						disabled={loading}>
						<span>Update</span>
					</button>
					{this.state.quantityError && this.tooltipParentName &&
						<Tooltip parent={this.tooltipParentName} type={"dialog--error"} messageObjects={showQuantityError} closeAction={this.props.clearUpdateMsg} />
					}
					{showErrorTooltip && this.tooltipParentName &&
						<Tooltip parent={this.tooltipParentName} type={'dialog--error'} messageObjects={this.props.updateError} closeAction={this.props.clearUpdateMsg} />
					}
					{showSuccessTooltip && this.tooltipParentName &&
						<Tooltip parent={this.tooltipParentName} type={'dialog--success'} messageObjects={{ success: this.props.updateSuccess }} closeAction={this.props.clearUpdateMsg} />
					}
				</div>
			</div>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		cart: state.cart,
		codes: state.cart.codes,
		updateSuccess: state.cart.updateSuccess,
		updateError: state.cart.updateError,
		updatedId: state.cart.updatedId,
		updateInProcess: state.cart.updateInProcess
	}
}

export default connect(mapStateToProps, { updateCartQty, removeCartCoupon, clearUpdateMsg })(UpdateQtyCell)



// WEBPACK FOOTER //
// ./src/components/cart/UpdateQtyCell.js